import { cx, css } from '@linaria/core';
import { flex } from 'styles/utils';
import { tooltipStyles } from 'components/Tooltip/Tooltip.styles';
export const tooltip = cx("omponents__List__components__Lock__Lock_styles_ts-tooltip-t1u9ei9", tooltipStyles);
export const container = "omponents__List__components__Lock__Lock_styles_ts-container-c1w6ww64";

require("./Lock.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Lock.styles.ts");